var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image",class:("is-" + _vm.size + "x" + _vm.size)},[_c('img',{staticClass:"w-full h-full ofit-cover",class:[_vm.imgClass, {'is-rounded': _vm.isRounded}],attrs:{"src":_vm.src,"alt":_vm.displayName}})])}
var staticRenderFns = []

export { render, staticRenderFns }